import React from 'react';
import { Routes, Route } from 'react-router';
import { Navigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import RecordsContextProvider from '../../state/recordsAdmin/RecordsContextProvider';
import RecordTimesContextProvider from '../../state/recordTimesAdmin/RecordTimesContextProvider';

import SelectOrgUnitContextProvider from '@usas/ui-web/state/selectOrgUnit/SelectOrgUnitContextProvider';
import PersonOrgRoleContextProvider from '@usas/ui-web/state/personOrgRole/PersonOrgRoleContextProvider';
import RecordGroupContextProvider from '@usas/ui-web/state/time/recordGroup/RecordGroupContextProvider';
import EventContextProvider from '@usas/ui-web/state/event/EventContextProvider';
import RecordAgeGroupContextProvider from '../../state/recordAgeGroup/RecordAgeGroupContextProvider';
import CourseContextProvider from '@usas/ui-web/state/course/CourseContextProvider';

import RecordsAdminContextView from './RecordsAdminContextView';

import OrgUnitSelection from './orgUnitSelection/OrgUnitSelection';
import RecordsAdminSearch from './recordsAdminSearch/RecordsAdminSearch';
import RecordsAdminCleanup from './recordsAdminCleanup/RecordsAdminCleanup';
import RecordsAdminListInstanceDetail from './recordsAdminListInstanceDetail/RecordsAdminListInstanceDetail';
import RecordsAdminEvents from './recordsAdminEvents/RecordsAdminEvents';
import RecordsAdminTimes from './recordsAdminTimes/RecordsAdminTimes';

import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';
import LoadingModal from '@usas/ui-web/components/dialogs/LoadingModal';
import SecuredRouteElement from '@usas/ui-web/components/security/SecuredRouteElement';

const ContextRoutes = ({ navRoutes }) => (
  <RecordsContextProvider>
    <RecordTimesContextProvider>
      <RecordGroupContextProvider>
        <RecordsAdminContextView>
          <CourseContextProvider>
          <EventContextProvider>
            <RecordAgeGroupContextProvider>
              <Routes>
                <Route path={navRoutes['RECORDS_ADMIN']?.path}
                  element={
                    <SecuredRouteElement
                      navRoute={navRoutes['RECORDS_ADMIN']}
                      editElement={<RecordsAdminSearch />} />
                  }
                />
                <Route path={navRoutes['RECORDS_CLEANUP']?.path}
                  element={
                    <SecuredRouteElement
                      navRoute={navRoutes['RECORDS_CLEANUP']}
                      editElement={<RecordsAdminCleanup />} />
                  }
                />
                <Route path={navRoutes['RECORDS_LIST_INSTANCE_DETAIL']?.path}
                  element={
                    <SecuredRouteElement
                      navRoute={navRoutes['RECORDS_LIST_INSTANCE_DETAIL']}
                      editElement={<RecordsAdminListInstanceDetail />} />
                  }
                />
                <Route path={navRoutes['RECORDS_EVENTS']?.path}
                  element={
                    <SecuredRouteElement
                      navRoute={navRoutes['RECORDS_EVENTS']}
                      editElement={<RecordsAdminEvents />} />
                  }
                />
                <Route path={navRoutes['RECORDS_TIMES']?.path}
                  element={
                    <SecuredRouteElement
                      navRoute={navRoutes['RECORDS_TIMES']}
                      editElement={<RecordsAdminTimes />} />
                  }
                />
              </Routes>
            </RecordAgeGroupContextProvider>
          </EventContextProvider>
          </CourseContextProvider>
        </RecordsAdminContextView>
      </RecordGroupContextProvider>
    </RecordTimesContextProvider>
  </RecordsContextProvider>
);

const RecordsAdminRoutes = () => {
  const { navRoutes, isReadyToRoute } = useNavRoutes();

  if (isReadyToRoute !== true) {
    return <LoadingModal />;
  }

  return (
    <Routes>
      <Route path={navRoutes['RECORDS_SELECTION']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['RECORDS_SELECTION']}
            editElement={<OrgUnitSelection />} />
        }
      />
      <Route path={'/*'} element={<ContextRoutes navRoutes={navRoutes} />} />
      <Route path={'/'} element={<Navigate to={navRoutes['RECORDS_SELECTION']?.route} replace />} />
    </Routes>
  )
};

const RecordsAdmin = () => (
  <SelectOrgUnitContextProvider>
    <PersonOrgRoleContextProvider>
      <RecordsAdminRoutes />
    </PersonOrgRoleContextProvider>
  </SelectOrgUnitContextProvider>
);

export default RecordsAdmin;